var Marionette = require('backbone.marionette');

var BreadcrumbView = require('common/views/BreadcrumbView');
var SideNavSectionView = require('common/views/SideNavSectionView');

var COCEventDetailsView = require('./COCEventDetailsView');
var COCEventVenueDetailsView = require('./COCEventVenueDetailsView');
var COCEventOrganizationDetailsView = require('./COCEventOrganizationDetailsView');
var COCEventSubmissionView = require('./COCEventSubmissionView');

var tmplCOCInternalCreateNewEventView = require('../templates/COCInternalCreateNewEventView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCInternalCreateNewEventView,

  className: 'coc-internal-create-new-event-view container-fluid',

  ui: {
    breadcrumb: '.breadcrumb-container',
    createNewEventContainer: '.create-new-event-container'
  },

  regions: {
    breadcrumb: '@ui.breadcrumb',
    createNewEventContainer: '@ui.createNewEventContainer'
  },

  onBeforeShow: function() {
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#coc/dashboard',
            text: 'Home'
          },
          {
            text: 'Create New Event'
          }
        ]
      })
    );

    var sideNavTabs = [
      {
        id: 'eventDetails',
        title: 'Event Details',
        showRequiredFieldDisclaimer: true,
        view: new COCEventDetailsView({
          model: this.model,
          isReadOnly: false
        })
      },
      {
        id: 'venueDetails',
        title: 'Venue Details',
        showRequiredFieldDisclaimer: true,
        view: new COCEventVenueDetailsView({ model: this.model, isReadOnly: false })
      },
      {
        id: 'organizationDetails',
        title: 'Organization Details',
        showRequiredFieldDisclaimer: true,
        view: new COCEventOrganizationDetailsView({ model: this.model, isReadOnly: false })
      },
      {
        id: 'submission',
        title: 'Submission',
        showRequiredFieldDisclaimer: true,
        view: new COCEventSubmissionView({ model: this.model, isReadOnly: false })
      }
    ];

    this.dashboard = new SideNavSectionView({
      collection: new Backbone.Collection(sideNavTabs),
      useNavigationButtons: true
      /*buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button save',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        }
      ]*/
    });

    this.showChildView('createNewEventContainer', this.dashboard);
  }

  //onClickSave: function() {}
});
